import React, { useEffect, useRef } from "react"

const TypeformEmbed = () => {
  const ref = useRef(null)

  useEffect(() => {
    // Wait until the full page loads
    const handleLoad = () => {
      if (!ref.current) return

      // Only add the embed once
      if (ref.current.childElementCount === 0) {
        const div = document.createElement("div")
        div.setAttribute("data-tf-live", "01K8RDW42WJRWEQDBEPSTVZDFE")
        ref.current.appendChild(div)

        const script = document.createElement("script")
        script.src = "https://embed.typeform.com/next/embed.js"
        script.async = true
        ref.current.appendChild(script)
      }
    }

    if (document.readyState === "complete") {
      handleLoad()
    } else {
      window.addEventListener("load", handleLoad)
      return () => window.removeEventListener("load", handleLoad)
    }
  }, [])

  return <div ref={ref}></div>
}

export default TypeformEmbed